import React from 'react';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import moment from 'moment';
import _ from "lodash";
import {Can} from "../../../ability-context";

import {fetchWarning, resetWarning, updateWarningStatus, updateWarningContent} from "../../../creators/warning";

import {Button} from "../Button";
import {PageLoader} from "../Loader";
import createLink from "../../../libs/createLink";
import {config} from "../../../config";
import {isNoFollowProfil} from "../../../libs/helper";
import WarningEditor from "./WarningEditor/WarningEditor";
import convertToNext from "../../../libs/lexical/convertissors/simple";

class WarningDetail extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            memberNoteState : {},
            moderatorNoteState : {},
            edit : {},
        }

        this.props.fetchWarning(this.props.warningId);
        // if(this.props.warningId){
        //     this.props.fetchWarning(this.props.userId,this.props.warningId);
        // }
    }

    componentWillUnmount() {
        this.props.resetWarning();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.props.fetchWarning(this.props.userId, this.props.warningId);
        }

    }

    handleSubmit() {

        let {text : note} = convertToNext(this.state.memberNoteState);
        let {text : moderatorNote} = convertToNext(this.state.moderatorNoteState);
        this.props.updateWarningContent(this.props.warningId, {
            note,
            moderatorNote
        });
        this.props.handleClose();

    }

    render() {

        let createdDate = this.props.warningInitialized && moment(this.props.warning.createdAt);
        let endDate = this.props.warningInitialized && moment(this.props.warning.restriction.endedAt !== null && this.props.warning.restriction.endedAt);
        let relLinkProfil = isNoFollowProfil(this.props.warning.moderator) ? { rel: "nofollow" } : {};
        let isCertified = (_.get(this.props.warning, "owner._id") && _.get(this.props.currentUser, "_id") && this.props.currentUser._id.toString() === this.props.warning.owner._id.toString() && !_.get(this.props.warning, "owner.profile.photoCertifiedId")) || false


        return !this.props.warningInitialized ? <PageLoader/> : (
            <div id="warningDetail" className="modal-container">
                <div className="modal-topline">Message de modération</div>
                <div className={"modal-body"}>
                    <div className="warning-detail-topline">
                        <div className={"column text medium black"}>
                            {this.props.warning.moderator && <span>Message de modération par <Link
                                to={createLink("userProfile", this.props.warning.moderator)} {...relLinkProfil}>{this.props.warning.moderator.username}</Link></span>}
                            <span>Raison: {this.props.warning.tag && (this.props.warning.tag.title || "Autre")} </span>
                            {/*<span>Dans {this.props.warning.owner && <Link*/}
                            {/*    to={createLink("userProfile", this.props.warning.owner)}>Profil</Link>}</span>*/}
                            <span>Restriction: {config.warningRestriction[_.get(this.props.warning,'restriction.type') || 0]}</span>
                            {this.props.warning.restriction.type === 1 && <span>Durée: {this.props.warning.restriction.isPermanent ? "Permanente" :
                               this.props.warning.restriction.startedAt ?
                                    `du ${moment(this.props.warning.restriction.startedAt).format("DD/MM/YYYY")} au ${moment(this.props.warning.restriction.endedAt).format("DD/MM/YYYY")}`
                                    :
                                   (
                                       `${endDate.diff(createdDate, 'hours') + 1} h`
                                   )
                                }
                            </span>}
                            <span>
                                {!this.props.warning.isAccepted ? (
                                    <div  className={"btn primary mr-8 btn-accepted"} onClick={()=> this.props.handleAccept(this.props.warningId)} >Accepter</div>
                                ) : null}

                                <Can action={"delete"} subject={this.props.warning} modelName="Warning">
                                    <div className={"btn cancel btn-deleted mr-8"} onClick={()=> this.props.handleDeleteWarn(this.props.warningId)} >
                                        Supprimer&nbsp;
                                    </div>
                                </Can>
                                <Can action={"update-status"} subject={this.props.warning} modelName="Warning">
                                    <div className={"btn btn-status "} onClick={()=> this.props.updateWarningStatus(this.props.warningId, {status : !this.props.warning.status})} >
                                        {this.props.warning.status ? "Désactiver" : "Activer"}
                                    </div>
                                </Can>
                            </span>

                        </div>
                    </div>
                    <div className="column my-16">
                        <div className="text label bold pb-4">Note au membre</div>
                        <div className="text medium black pre-line">
                            <Can action="update-status" subject="Warning" passThrough>
                                {can => {
                                    return can ? (
                                        <WarningEditor onChange={(editorState)=>this.setState({memberNoteState:editorState})}  text={this.props.warning.note}/>
                                    ) : (
                                        this.props.warning.note
                                    )
                                }}
                            </Can>

                        </div>
                    </div>
                    <Can action="update-status" subject="Warning">
                        <div className="column my-16">
                            <div className="text label bold pb-4">Note pour les modérateurs</div>
                            <div className="text medium black pre-line">
                                <WarningEditor onChange={(editorState)=>this.setState({moderatorNoteState:editorState})}  text={this.props.warning.moderatorNote}/>
                            </div>
                        </div>
                    </Can>

                </div>
                <div className="modal-baseline">
                    <div className={"link-group"}>
                        <a  className={"btn primary mr-8"} href={createLink("charter")} target={"_blank"} rel="noopener noreferrer">
                            Charte
                        </a>

                        <a  className={"btn primary mr-8"} href={"mailto:Assistance@voissa.com"}>
                            Assistance@voissa.com
                        </a>

                        {isCertified ? <a className={"btn primary"} href={createLink("userMeSettingsAbonnement")} target={"_blank"} rel="noopener noreferrer">
                           Certifier mon compte
                        </a> : null}
                    </div>
                    <Can action="update" subject="Warning">
                        <Button className="btn-close"
                                size={"small"}
                                btnStyle={"primary"}
                                onClick={() => this.handleSubmit()}
                                content={"Valider"}/>
                    </Can>
                    <Button className="btn-close"
                            size={"small"}
                            btnStyle={"primary-reverse"}
                            onClick={() => this.props.handleClose()}
                            content={"Fermer"}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        warning: state.warning.data,
        warningLoading: state.warning.loading,
        warningInitialized: state.warning.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetWarning,
    fetchWarning,
    updateWarningStatus,
    updateWarningContent
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(WarningDetail);

